import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from '../toasts/toasts.service';
import { StockService } from 'app/sections/stocks/services/stock.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from 'app/common/login/login.component';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, OnDestroy {

  @Input('section') section : 'stocks' | 'crypto' = null;
  @Input('type') type: 'news' | 'twitter' | 'stocktwitt' = null;
  @Input('title') title: string = null;
  private shareTickerSubscription: Subscription;
  public newsData = [];
  public saveNewsData = [];
  public loading: boolean = false;
  private _unsubscribeAll: Subject<any>;
  public activeTab = 1;
  public selectedTicker: string = null;
  private newsLimit: number = 10;
  public currentPage: number = 1;
  public newsTotalCount: number = 0;

  constructor(
    public stockService: StockService, 
    public  _toastService: ToastService, 
    private _cd: ChangeDetectorRef,
    private modalService: NgbModal) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.getTicker();
  }

  ngOnDestroy(): void {
    if(this.shareTickerSubscription) this.shareTickerSubscription.unsubscribe();
  }

  getTicker(){
    this.shareTickerSubscription = this.stockService.shareTicker.subscribe((row:any)=>{
      if(row && this.selectedTicker != row?.ticker){
        this.selectedTicker = row?.ticker;
        this.currentPage = 1;
        this.newsTotalCount = 0;
        let offset = this.newsLimit * (this.currentPage - 1);
        if(this.type == 'news'){
          this.getTickerNews(this.selectedTicker);
        } else {
          this.getSocialSentimentTrends(this.type, this.selectedTicker, this.newsLimit, offset);
        }
      }
    })
  }

  getTickerNews(ticker: string){
    this.loading = true;
    this.stockService.getNews(ticker.toLowerCase()).pipe(takeUntil(this._unsubscribeAll)).subscribe((data:any)=>{
      this.newsData = data.data.results;
      this.newsTotalCount = this.newsData.length;
      this.loading = false;
    });
    this.getSavedNewsData();
  }

  getSocialSentimentTrends(type : 'stocktwitt' | 'twitter', ticker: string, limit: number, offset: number){
    this.loading = true;
    this.stockService.getSocialSentimentTrends(type, ticker, limit, offset).pipe(takeUntil(this._unsubscribeAll)).subscribe((result)=>{
      let data : [] = result.data;
      this.newsTotalCount = result.pagination.count;
      this._cd.markForCheck();
      this.loading = false;
      switch (type) {
        case 'twitter':
          this.newsData = data.map((element:any)=>{
            element['tweet_by'] = element.username;
            return element;
          });
          this._cd.markForCheck();
          break;
        case 'stocktwitt':
          this.newsData = data.map((element:any)=>{
            element['tweet_by'] = element.name;
            element['postDate'] = moment(element.createdAt).format('MM/DD/YYYY hh:mma')
            return element;
          });
          this._cd.markForCheck();
          break;
      }
    });
    this.getSocialSentiment(type);
  }

  getSocialSentiment(pageName){
    this.stockService.getSocialSentiment(this.toTitleCase(pageName)).pipe(takeUntil(this._unsubscribeAll)).subscribe((data: any[])=>{
      this.saveNewsData = data;
    });
  }

  toTitleCase(str: string) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  public pageChange(event){
    this.currentPage = event;
    if(this.type != 'news'){
      let offset = this.newsLimit * (this.currentPage - 1);
      this.getSocialSentimentTrends(this.type, this.selectedTicker, this.newsLimit, offset);
    }
  }

  addSocialSentiment(id){
    this.stockService.addSocialSentiment({
      CollectionType: this.toTitleCase(this.type),
      ObjectID: id,
      recordedOn: moment().format('MM/DD/YYYY')
    }).toPromise().then((data)=>{
      if(data.status == 1001){
        this._toastService.show('Data Added', {
          delay: 2000,
          classname: 'bg-success text-light',
          autohide: true
        });
        this.getSocialSentiment(this.type)
      } else {
        this.modalService.open(LoginComponent, {
          size: 'sm',
          centered: true
        });
      }
    });
  }

  deleteSocialSentiment(id){
    this.stockService.deleteSocialSentiment(id).pipe(takeUntil(this._unsubscribeAll)).toPromise().then((data) =>{
      if(data.status == 1001){
        this._toastService.show('Data Deleted', {
          delay: 2000,
          classname: 'bg-danger text-light',
          autohide: true
        });
        this.getSocialSentiment(this.type);  
      } else {
        this.modalService.open(LoginComponent, {
          size: 'sm',
          centered: true
        });
      }
    })
  }

  getSavedNewsData(){
    this.stockService.getUserNews().pipe(takeUntil(this._unsubscribeAll)).subscribe((result:any)=>{
      this.saveNewsData = result.data;
    });
  }

  deleteNews(id){
    this.stockService.deleteUserNews(id).pipe(takeUntil(this._unsubscribeAll)).subscribe((result)=>{
      this._toastService.show('News Deleted', {
        delay: 2000,
        classname: 'bg-danger text-light',
        autohide: true
      });
      this.getSavedNewsData();
    });
  }

}
